import type { SiteExportViewModel } from "@lumora/core";
import { useViewModel } from "@lumora/ui";

export interface SiteExportSectionProps {
  viewModel: SiteExportViewModel;
}

/** Owner records download. Pure view — commands live on SiteExportViewModel. */
export function SiteExportSection({ viewModel }: SiteExportSectionProps) {
  const state = useViewModel(viewModel);

  return (
    <section className="portal-section" data-lumora-view="site-export">
      <h2>Your records</h2>
      <p data-lumora-lead>
        Download a copy of your business records whenever you need it. The file includes
        your site details, hours, locations, menu, orders, inquiries, and account contacts.
        You can request this even after you cancel.
      </p>

      {state.loading ? <p>Preparing your export…</p> : null}

      {state.error ? (
        <>
          <p data-lumora-error className="portal-error">
            {state.error}
          </p>
          <button
            type="button"
            className="portal-btn"
            disabled={state.loading}
            onClick={() => void viewModel.download()}
          >
            Try again
          </button>
        </>
      ) : null}

      {!state.loading && !state.error && !state.lastFilename ? (
        <p className="portal-notice">No download has started yet. Use Export my data when you want a copy of your records.</p>
      ) : null}

      {!state.loading && !state.error && state.lastFilename ? (
        <p>Your export is ready in your downloads folder.</p>
      ) : null}

      <button
        type="button"
        className="portal-btn"
        disabled={state.loading}
        onClick={() => void viewModel.download()}
      >
        {state.loading ? "Preparing your export…" : "Export my data"}
      </button>
    </section>
  );
}
